import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    GetAllNotes as getNotesApi,
    CreateNote as addNotesApi,
    UpdateNote as updateNotesApi,
    DeleteNote as deleteNotesApi,
    GetDraftNotes as getDraftNotesApi,
    SaveDraft as saveDraftApi,
    GetNoteHistory as getNoteHistoryApi,
    GetUserNotesHistory as getUserNotesHistoryApi,
    GetCompanyNotesHistory as getCompanyNotesHistoryApi
} from "../../helpers/api_method";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getNotes = createAsyncThunk("notes/getNotes", async () => {
    try {
        const response = await getNotesApi();
        // Handle the API response structure: {data: [], message: "...", status: true}
        if (response && response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        toast.error("Failed to fetch notes", { autoClose: 2000 });
        return [];
    }
});
export const addNotes = createAsyncThunk("notes/addNotes", async (event: any) => {
    try {
        const response = await addNotesApi({
            notes_title: event.title,
            description: event.description,
            category: event.category,
            is_favorite: event.is_favorite || false
        });
        toast.success("Notes Added Successfully", { autoClose: 2000 });
        // Handle the API response structure: {data: {...}, message: "...", status: true}
        return response.data;
    } catch (error) {
        toast.error("Notes Added Failed", { autoClose: 2000 });
        throw error;
    }
});

export const updateNotes = createAsyncThunk("notes/updateNotes", async (event: any) => {
    try {
        const response = await updateNotesApi(event.id, {
            notes_title: event.title,
            description: event.description,
            category: event.category,
            is_favorite: event.is_favorite || false
        });
        toast.success("Notes updated Successfully", { autoClose: 2000 });
        // Handle the API response structure: {data: {...}, message: "...", status: true}
        return response.data;
    } catch (error) {
        toast.error("Notes updated Failed", { autoClose: 2000 });
        throw error;
    }
});

export const deleteNotes = createAsyncThunk("notes/deleteNotes", async (id: any) => {
    try {
        const response = await deleteNotesApi(id);
        toast.success("Notes deleted Successfully", { autoClose: 2000 });
        return id;
    } catch (error: any) {
        const errorMessage = error?.response?.data?.message || error?.message || "Notes deletion failed";
        toast.error(errorMessage, { autoClose: 2000 });
        throw error;
    }
});

export const getDraftNotes = createAsyncThunk("notes/getDraftNotes", async () => {
    try {
        const response = await getDraftNotesApi();
        if (response && response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Failed to fetch draft notes:", error);
        return [];
    }
});

export const saveDraft = createAsyncThunk("notes/saveDraft", async (draftData: any) => {
    try {
        const response = await saveDraftApi(draftData);
        return response.data;
    } catch (error) {
        console.error("Failed to save draft:", error);
        throw error;
    }
});

export const getNoteHistory = createAsyncThunk("notes/getNoteHistory", async (noteId: string) => {
    try {
        const response = await getNoteHistoryApi(noteId);
        if (response && response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Failed to fetch note history:", error);
        return [];
    }
});

export const getUserNotesHistory = createAsyncThunk("notes/getUserNotesHistory", async () => {
    try {
        const response = await getUserNotesHistoryApi();
        if (response && response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Failed to fetch user notes history:", error);
        return [];
    }
});

export const getCompanyNotesHistory = createAsyncThunk("notes/getCompanyNotesHistory", async () => {
    try {
        const response = await getCompanyNotesHistoryApi();
        if (response && response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Failed to fetch company notes history:", error);
        return [];
    }
});